import { render, staticRenderFns } from "./ListRealized.vue?vue&type=template&id=5673070a&scoped=true&"
import script from "./ListRealized.vue?vue&type=script&lang=js&"
export * from "./ListRealized.vue?vue&type=script&lang=js&"
import style0 from "./ListRealized.vue?vue&type=style&index=0&id=5673070a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673070a",
  null
  
)

export default component.exports